export function  copy(content) {
    const text = document.createElement('textarea');
    text.value = content;
    document.body.appendChild(text);
    text.select(); // 选择对象
    if (document.execCommand('copy')) {
      document.execCommand('copy');
    }
    // 执行浏览器复制命令
    document.body.removeChild(text);
    this.$message({
      type: 'success',
      message: this.$t('message.copySuccessfully')
    })
}
